module.exports = "/_next/static/images/43a7aaa9c83e772c2e314a95e7934e12-people-smile-at-home-xs@3x.jpg";